"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactSimpleCodeEditor = _interopRequireDefault(require("react-simple-code-editor"));
var _prismCore = require("prismjs/components/prism-core");
require("prismjs/components/prism-clike");
require("prismjs/components/prism-javascript");
require("prismjs/components/prism-json");
require("prismjs/components/prism-graphql");
require("./styles.scss");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _gui = require("../../../../reducers/gui.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Editor = /*#__PURE__*/function (_React$Component) {
  _inherits(Editor, _React$Component);
  function Editor() {
    var _this;
    _classCallCheck(this, Editor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Editor, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      editorData: '',
      mode: _this.props.mode
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
        files = _this$props.files,
        filename = _this$props.filename,
        inputString = _this$props.inputString;
      if (filename) {
        if (filename.match(/\.graphql$/)) {
          _this.setState({
            mode: 'graphql'
          });
        }
        var file = files[filename];
        var contents = file ? file.contents : '';
        _this.setState({
          editorData: contents
        });
      } else {
        _this.setState({
          editorData: inputString
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "editorRefresh", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props2, files, filename, inputString, contents;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props2 = _this.props, files = _this$props2.files, filename = _this$props2.filename, inputString = _this$props2.inputString;
            if (filename) {
              _context.next = 4;
              break;
            }
            _this.setState({
              editorData: inputString
            });
            return _context.abrupt("return");
          case 4:
            contents = files[filename] ? files[filename].contents : '';
            _this.setState({
              editorData: contents
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "editorSave", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var overwriteAllModified,
          _this$state,
          mode,
          editorData,
          _this$props3,
          files,
          filename,
          jsonAsObj,
          filesToWrite,
          response,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              overwriteAllModified = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              _this$state = _this.state, mode = _this$state.mode, editorData = _this$state.editorData;
              _this$props3 = _this.props, files = _this$props3.files, filename = _this$props3.filename;
              if (filename) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              jsonAsObj = editorData;
              if (!(mode === 'json' && filename)) {
                _context2.next = 18;
                break;
              }
              _context2.prev = 7;
              _context2.next = 10;
              return JSON.parse(editorData);
            case 10:
              jsonAsObj = _context2.sent;
              _context2.next = 17;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](7);
              (0, _cccisdNotification["default"])({
                duration: 2250,
                message: 'JSON did not parse, please correct.',
                type: 'danger'
              });
              return _context2.abrupt("return");
            case 17:
              _this.setState({
                editorData: JSON.stringify(jsonAsObj, null, 4)
              });
            case 18:
              _this.setState({
                disableWrite: true
              });
              filesToWrite = [{
                filename: filename,
                contents: mode === 'json' ? JSON.stringify(jsonAsObj, null, 4) : editorData,
                modified: files[filename] ? files[filename].modified : ''
              }];
              _context2.next = 22;
              return _this.props.changeLocalFiles(filesToWrite);
            case 22:
              _context2.next = 24;
              return _this.props.writeFiles(filesToWrite.map(function (fileData) {
                return fileData.filename;
              }), overwriteAllModified);
            case 24:
              response = _context2.sent;
              if (!(response.status !== 200)) {
                _context2.next = 30;
                break;
              }
              (0, _cccisdNotification["default"])({
                duration: 2250,
                message: 'Encountered error while writing file',
                type: 'danger'
              });
              _this.setState({
                disableWrite: false
              });
              _context2.next = 43;
              break;
            case 30:
              if (!(response.data.status === 'success')) {
                _context2.next = 34;
                break;
              }
              _this.setState({
                disableWrite: false
              });
              _context2.next = 43;
              break;
            case 34:
              _context2.prev = 34;
              _context2.next = 37;
              return (0, _cccisdConfirm["default"])({
                message: "Warning: This file has been modified on the filesystem while you've been working.",
                description: "Would you like to overwrite the file `".concat(filename, "`?")
              });
            case 37:
              _this.editorSave(null, true);
              _context2.next = 43;
              break;
            case 40:
              _context2.prev = 40;
              _context2.t1 = _context2["catch"](34);
              _this.setState({
                disableWrite: false
              });
            case 43:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[7, 13], [34, 40]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(inputJson) {
        var onChange;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              onChange = _this.props.onChange;
              onChange(inputJson);
              if (_this.state.editorData !== inputJson) {
                _this.setState({
                  editorData: inputJson
                });
              }
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(Editor, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        disableWrite = _this$state2.disableWrite,
        mode = _this$state2.mode,
        editorData = _this$state2.editorData;
      var filename = this.props.filename;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "language-".concat(mode)
      }, /*#__PURE__*/_react["default"].createElement(_reactSimpleCodeEditor["default"], {
        highlight: function highlight(code) {
          return (0, _prismCore.highlight)(code, _prismCore.languages[mode]);
        },
        onValueChange: this.handleOnChange,
        padding: 14,
        style: {
          background: '#f5f2f0',
          borderRadius: '4px',
          boxSizing: 'border-box',
          caretColor: '#333',
          fontFamily: 'Menlo, Courier, "Courier New", monospace',
          fontSize: 14,
          minHeight: '25em'
        },
        tabSize: 4,
        value: editorData
      })), filename && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em',
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "pull-right btn btn-default btn-primary".concat(disableWrite ? ' disabled' : ''),
        onClick: this.editorSave,
        style: {
          marginLeft: '1em'
        }
      }, "Save"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "pull-right btn btn-default",
        onClick: this.editorRefresh
      }, "Refresh")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix",
        style: {
          marginBottom: '1em',
          marginTop: '1em'
        }
      })));
    }
  }]);
  return Editor;
}(_react["default"].Component);
_defineProperty(Editor, "propTypes", {
  /** The string to edit. Not used if 'filename' prop provided. */
  inputString: _propTypes["default"].string,
  /** Method to save file in redux */
  changeLocalFiles: _propTypes["default"].func,
  /** The files in redux */
  files: _propTypes["default"].object,
  /** The filename to edit (pulled from redux) */
  filename: _propTypes["default"].string,
  /** The mode that should be used when editing the file (defaults to 'json') */
  mode: _propTypes["default"].string,
  /** Method called with editor data as argument on change */
  onChange: _propTypes["default"].func,
  /** Method to write files to back-end */
  writeFiles: _propTypes["default"].func
});
_defineProperty(Editor, "defaultProps", {
  inputString: '',
  filename: '',
  mode: 'json',
  onChange: function onChange(data) {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    files: state.appdefs.gui.files
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeLocalFiles: _gui.changeLocalFiles,
  writeFiles: _gui.writeFiles
})(Editor);